"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.SaleClient = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _http = require("@tajawal/web-core-sdk-v2/lib/services/http.service");
var _client = require("@tajawal/web-core-sdk-v2/lib/utils/client.utils");
var _constants = require("../constants");
var _omit2 = _interopRequireDefault(require("lodash/omit"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var SaleClient = exports.SaleClient = {
  createSale: function createSale(itineraryId, headers) {
    if (headers === void 0) {
      headers = {};
    }
    var requestId = "CREATE_FLIGHT_SALE";
    var endPoint = _constants.ENDPOINTS.CREATE_SALE.replace("{itineraryId}", itineraryId);
    var config = {
      headers: _objectSpread({
        "x-pricing-version": 1
      }, headers)
    };
    return _http.$http.get(requestId, endPoint, config).then(function (_ref) {
      var data = _ref.data;
      return data;
    });
  },
  createSaleByCart: function createSaleByCart(cartId, searchParams, headers) {
    if (searchParams === void 0) {
      searchParams = "";
    }
    if (headers === void 0) {
      headers = {};
    }
    var requestId = "CREATE_FLIGHT_SALE_FROM_CART";
    var endPoint = _constants.ENDPOINTS.CREATE_SALE_FROM_CART.replace("{cartId}", cartId);
    var params = new URLSearchParams(searchParams);
    var config = {
      headers: _objectSpread({
        "x-pricing-version": 1
      }, headers),
      params: params
    };
    return _http.$http.post(requestId, endPoint, config).then(function (_ref2) {
      var data = _ref2.data;
      return data;
    });
  },
  getSale: function getSale(saleId, searchParams, timeout) {
    if (searchParams === void 0) {
      searchParams = "";
    }
    if (timeout === void 0) {
      timeout = 0;
    }
    var requestId = "GET_SALE";
    var endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.GET_SALE, {
      saleId: saleId
    });
    var config = _objectSpread({
      headers: {
        "Cache-Control": "private, no-cache, no-store, must-revalidate",
        Expires: "-1",
        Pragma: "no-cache",
        "x-pricing-version": 1
      }
    }, timeout > 1 ? {
      timeout: timeout
    } : {});
    return _http.$http.get(requestId, endPoint + searchParams, config).then(function (_ref3) {
      var data = _ref3.data;
      return data;
    });
  },
  sellSeat: function sellSeat(payload, headers) {
    if (headers === void 0) {
      headers = {};
    }
    var requestId = "SEAT_RESERVATION_FLIGHT_SALE";
    var saleId = payload.saleId,
      cartId = payload.cartId;
    var endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.SALE_SEAT_RESERVATION, {
      saleId: saleId,
      cartId: cartId
    });
    return _http.$http.post(requestId, endPoint, {
      data: (0, _omit2.default)(payload, ["saleId", "cartId"]),
      headers: headers
    }).then(function (_ref4) {
      var data = _ref4.data;
      return data;
    });
  },
  updateSSR: function updateSSR(payload) {
    var requestId = "SSR_UPDATE_FLIGHT_CART";
    var saleId = payload.saleId,
      cartId = payload.cartId;
    var endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.SSR_UPDATE, {
      saleId: saleId,
      cartId: cartId
    });
    return _http.$http.put(requestId, endPoint, {
      data: (0, _omit2.default)(payload, ["saleId", "cartId"])
    }).then(function (_ref5) {
      var data = _ref5.data;
      return data;
    });
  },
  updateMultiSSR: function updateMultiSSR(payload) {
    var requestId = "MULTI_SSR_UPDATE_FLIGHT_SALE";
    var saleId = payload.saleId,
      cartId = payload.cartId;
    var endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.MULTI_SSR_UPDATE, {
      saleId: saleId,
      cartId: cartId
    });
    return _http.$http.put(requestId, endPoint, {
      data: (0, _omit2.default)(payload, ["saleId", "cartId"])
    }).then(function (_ref6) {
      var data = _ref6.data;
      return data;
    });
  },
  updateAddOns: function updateAddOns(cartId, addOns) {
    if (addOns === void 0) {
      addOns = [];
    }
    var requestId = "ADDON_FLIGHT_CART";
    var endPoint = _constants.ENDPOINTS.ADDON;
    return _http.$http.post(requestId, endPoint, {
      data: {
        cartId: cartId,
        addOn: addOns
      }
    }).then(function (_ref7) {
      var data = _ref7.data;
      return data;
    });
  },
  applyAddOn: function applyAddOn(saleId, cartId, payload) {
    var endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.APPLY_ADD_ON, {
      saleId: saleId,
      cartId: cartId
    });
    var packageId = payload.addOnId,
      priceDetails = payload.priceDetails;
    var requestId = packageId + "_APPLY_ADD_ON";
    return _http.$http.post(requestId, endPoint, {
      data: {
        priceDetails: priceDetails,
        packageId: packageId
      }
    }).then(function (_ref8) {
      var data = _ref8.data;
      return data;
    });
  },
  removeAddOn: function removeAddOn(saleId, flightCartId, addOnId) {
    var requestId = addOnId + "_REMOVE_ADD_ON";
    var endPoint = (0, _client.replaceParams)(_constants.ENDPOINTS.REMOVE_ADD_ON, {
      saleId: saleId,
      cartId: flightCartId,
      packageId: addOnId
    });
    return _http.$http.delete(requestId, endPoint).then(function (_ref9) {
      var data = _ref9.data;
      return data;
    });
  }
};